import { Component,Renderer } from '@angular/core';
import { IonicPage, NavController, NavParams,ViewController ,Events} from 'ionic-angular';
import {CalendarComponentOptions, CalendarModal, CalendarModalOptions, DayConfig, CalendarResult } from "ion2-calendar";
import * as moment from 'moment';

/**
 * Generated class for the CalendarModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-calendar-modal',
  templateUrl: 'calendar-modal.html',
})
export class CalendarModalPage {
  startDate1: Date = new Date();
  endDate1: Date = new Date();
  startDate: string = "";
  endDate: string = "";
  startDateD: Date = new Date(Date.now() - 24 * 60 * 60 * 1000 * 3);
  endDateD: Date = new Date();
  cancelAction : boolean;

 dateRange: {
    from: Date;
    to: Date
  } = {
    from: new Date(Date.now() - 24 * 60 * 60 * 1000 * 4),
    to: new Date()
};
  type: 'string';

options: CalendarModalOptions = {
          pickMode: 'range',
          //title: 'RANGE',
          //defaultDateRange : { from: this.startDate, to:  new Date() },
          from : new Date(2018, 0, 1),
          to:  new Date(),
        };

  constructor(
    params: NavParams,
    public renderer: Renderer,
    public viewCtrl: ViewController,
    public events: Events,
    public navctrl :NavController
  ) {
    this.renderer.setElementClass(viewCtrl.pageRef().nativeElement, 'my-popup', true);
    //this.startDate1.setTime(this.startDate1.getTime() - 3 * 86400000);
    //this.startDate = this.startDate1.toISOString();
    //this.endDate = this.endDate1.toISOString();
    this.dateInit();
    this.cancelAction = false;

  }

  cancel(){

    this.cancelAction = true;
    this.dismiss();

  }

   dismiss() {
     let data;

     if (this.cancelAction){
       data = null;
     }else{
       data = {"startdate" :this.startDateD,"enddate" :this.endDateD};
     }
     this.viewCtrl.dismiss(data);
}

 onChange($event) {
    console.log($event.from.format('YYYY-MM-DD')+" "+$event.to.format('YYYY-MM-DD'));
    this.startDate = $event.from.format('DD-MM-YYYY');
    this.endDate = $event.to.format('DD-MM-YYYY');
    this.startDateD = $event.from.toString();
    this.endDateD = $event.to.toString();
    
}


dateInit(){

  this.startDate = this.toString(new Date(Date.now() - 24 * 60 * 60 * 1000 * 2));
  this.endDate = this.toString(new Date());
    
}

submit(){

  
}

 toString(date : Date) : string{
   let j : string = "0"+String(date.getDate());
   let m : string = "0"+String(date.getMonth());
   if(date.getDate()<10 && (date.getMonth()>10)){
    return  j+"-"+String(date.getMonth())+"-"+String(date.getUTCFullYear());

   }else if ((date.getMonth()<10) && (date.getDate()>10)){

    return String(date.getDate())+"-"+m+"-"+String(date.getUTCFullYear());

   }else if ((date.getMonth()<10) && (date.getDate()<10)){

    return j+"-"+m+"-"+String(date.getUTCFullYear());
   }

  return  String(date.getDate())+"-"+String(date.getMonth())+"-"+String(date.getUTCFullYear());
}

}



// WEBPACK FOOTER //
// ./src/pages/historical-form/calendar-modal/calendar-modal.ts